// src/MyAccount.js
import React, { useEffect, useState } from 'react';
import {Edit, SimpleForm, TextInput, required, Toolbar, SaveButton, useNotify, useAuthProvider} from 'react-admin';


/**
 * MyAccount
 * Uses React-Admin's Edit + SimpleForm with id from localStorage,
 * and custom actions to hide the Delete button.
 */
export const MyAccountEdit = (props) => {
    const [userId, setUserId] = useState(null);
    const notify = useNotify();
    
    useEffect(() => {
        // Get user ID from localStorage (stored by authProvider during login)
        const storedUserId = localStorage.getItem('user_id');
        if (storedUserId) {
            setUserId(parseInt(storedUserId, 10));
        } else {
            console.error('No user_id found in localStorage');
            setUserId(null);
        }
    }, []);

    if (!userId) {
        return <div>Loading user data...</div>;
    }

    return (
        <Edit
            {...props}
            resource="my-account"
            id={userId}
            title="My Account"
            undoable={false}
            redirect={false}
            mutationMode="pessimistic"
            mutationOptions={{
                onSuccess: () => {
                    notify('Dane zostały pomyślnie zaktualizowane', { type: 'success' });
                },
            }}
        >
            <SimpleForm toolbar={<Toolbar><SaveButton /></Toolbar>} redirect={false} >
                <TextInput disabled source="email" />
                <TextInput source="first_name" label="First Name" />
                <TextInput source="last_name"  label="Last Name" />
            </SimpleForm>
        </Edit>
    );
};

export const MyAccountList = (props) => {
    const notify = useNotify();
    const [userId, setUserId] = useState(null);
    
    useEffect(() => {
        // Get user ID from localStorage (stored by authProvider during login)
        const storedUserId = localStorage.getItem('user_id');
        if (storedUserId) {
            setUserId(parseInt(storedUserId, 10));
        } else {
            console.error('No user_id found in localStorage');
            setUserId(null);
        }
    }, []);

    if (!userId) {
        return <div>Loading user data...</div>;
    }

    return (
        <Edit
            {...props}
            resource="my-account"
            id={userId}
            title="My Account"
            mutationMode="pessimistic"
            mutationOptions={{
                onSuccess: () => {
                    notify('Data changed successfully', { type: 'success' });
                },
            }}
        >
            <SimpleForm toolbar={<Toolbar><SaveButton /></Toolbar>} redirect={false} >
                <TextInput disabled source="email" />
                <TextInput source="first_name" label="First Name" />
                <TextInput source="last_name"  label="Last Name" />
            </SimpleForm>
        </Edit>
    );
};

